export default "__VITE_ASSET__BCVqmReT__"